import Vue from "vue";
import Vuex from "vuex";
import { getLanguage } from "@/lang/index.js";

Vue.use(Vuex);

const state = {
  language: getLanguage(),
};

const getters = {
  language: (state) => {
    return state.language;
  },
};

const mutations = {
  SET_LANGUAGE: (state, language) => {
    state.language = language;
    sessionStorage.setItem("language", language);
  },
};

const actions = {
  setLanguage({ commit }, language) {
    console.log("setLanguage", language);
    commit("SET_LANGUAGE", language);
  },
};

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
  modules: {},
});
